import { Prisma } from '@repo/database/src/types';

import { agentDealWithRegion } from './agent-deal.dto';

export const agentWithIncludes = {
  include: {
    userAgreements: {
      include: {
        weeklyRakeStats: {
          select: { rakeSharePercentage: true },
        },
      },
    },
    agentDeal: agentDealWithRegion,
  },
} satisfies Prisma.UserDefaultArgs;

export type AgentWithIncludesDto = Prisma.UserGetPayload<typeof agentWithIncludes>;
